import React from 'react';
import { Tag } from 'antd';

import { RightSidebar } from "src/pages/_partials/Layout";
import { DeviceInterface } from "src/store/callrecorder/devicesSlice";
import RowInfo from "src/componets/RowInfo";
import { formattedDate } from "src/helpers/DateHelpers";
import OptionalLink from "src/componets/OptionalLink";
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

const _SidebarShow = ({ record }: { record: DeviceInterface | undefined }) => {
  const renderDetails = () => {
    if (!record) {
      return null;
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Identity</h6>

          <RowInfo left='#ID' right={record.id} />
          <RowInfo left='XDID' right={record.xdid || '—'} />
          <RowInfo left='User' right={
            <OptionalLink link={callrecorderUrls.userPath(record.user_id)}>
              {`#${record.user_id}`}
            </OptionalLink>
          } />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>App Info</h6>

          <RowInfo left='Bundle' right={record.bundle} />
          <RowInfo left='Vendor' right={record.vendor} />
          <RowInfo left='Advertise' right={record.advertise} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Registration</h6>

          <RowInfo left='Reg Bundle' right={record.reg_bundle || '—'} />
          <RowInfo left='Reg Vendor' right={record.reg_vendor || '—'} />
          <RowInfo left='Reg Advertise' right={record.reg_advertise || '—'} />
          <RowInfo left='Reg User ID' right={record.reg_user_id || '—'} />
          <RowInfo left='Reg Sign-in IP' right={record.reg_sign_in_ip || '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Location</h6>

          <RowInfo left='Country' right={record.country_code || '—'} />
          <RowInfo left='Language' right={record.language || '—'} />
          <RowInfo left='Timezone' right={record.timezone !== null ? record.timezone : '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Sign-in</h6>

          <RowInfo left='Sign-in Count' right={record.sign_in_count} />
          <RowInfo left='Current Sign-in' right={record.current_sign_in_at ? formattedDate(record.current_sign_in_at).dateTime : '—'} />
          <RowInfo left='Last Sign-in' right={record.last_sign_in_at ? formattedDate(record.last_sign_in_at).dateTime : '—'} />
          <RowInfo left='Current IP' right={record.current_sign_in_ip || '—'} />
          <RowInfo left='Last IP' right={record.last_sign_in_ip || '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Status</h6>

          <RowInfo left='Deleted' right={record.is_deleted ? <Tag color="error">yes</Tag> : <Tag color="default">no</Tag>} />
          <RowInfo left='Notify Token' right={record.notify_token ? <small>{record.notify_token}</small> : '—'} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar collapsible>
      <h6 className='v-content-label'>DEVICE DETAILS</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
